import { beautifyCamelCaseString } from "src/app/common/stringUtils";
import { ViolationStatusReason } from "../api/violations.model";
import { FilterTypesEnum } from "../filters/filterTypes.enum";
import { ISelectOption } from "./selectOption.interface";

export const ViolationStatusReasonSelectOptions: ISelectOption[] = [
    {
        id: `${FilterTypesEnum.ViolationStatusReason.toString()}-${ViolationStatusReason.openedByZenity}`,
        value: ViolationStatusReason.openedByZenity,
        displayName: "Open - " + beautifyCamelCaseString(ViolationStatusReason.openedByZenity),
        filterType: FilterTypesEnum.ViolationStatusReason,
        categoryName: FilterTypesEnum.ViolationStatusReason.toString(),
    },
    {
        id: `${FilterTypesEnum.ViolationStatusReason.toString()}-${ViolationStatusReason.reopenedByZenity}`,
        value: ViolationStatusReason.reopenedByZenity,
        displayName: "Open - " + beautifyCamelCaseString(ViolationStatusReason.reopenedByZenity),
        filterType: FilterTypesEnum.ViolationStatusReason,
        categoryName: FilterTypesEnum.ViolationStatusReason.toString(),
    },
    {
        id: `${FilterTypesEnum.ViolationStatusReason.toString()}-${ViolationStatusReason.exemptedByUser}`,
        value: ViolationStatusReason.exemptedByUser,
        displayName: beautifyCamelCaseString(ViolationStatusReason.exemptedByUser),
        filterType: FilterTypesEnum.ViolationStatusReason,
        categoryName: FilterTypesEnum.ViolationStatusReason.toString(),
    },
    {
        id: `${FilterTypesEnum.ViolationStatusReason.toString()}-${ViolationStatusReason.resourceDeleted}`,
        value: ViolationStatusReason.resourceDeleted,
        displayName: "Resolved - " + beautifyCamelCaseString(ViolationStatusReason.resourceDeleted),
        filterType: FilterTypesEnum.ViolationStatusReason,
        categoryName: FilterTypesEnum.ViolationStatusReason.toString(),
    },
    {
        id: `${FilterTypesEnum.ViolationStatusReason.toString()}-${ViolationStatusReason.ruleUpdatedByZenity}`,
        value: ViolationStatusReason.ruleUpdatedByZenity,
        displayName: "Resolved - " + beautifyCamelCaseString(ViolationStatusReason.ruleUpdatedByZenity),
        filterType: FilterTypesEnum.ViolationStatusReason,
        categoryName: FilterTypesEnum.ViolationStatusReason.toString(),
    },
    {
        id: `${FilterTypesEnum.ViolationStatusReason.toString()}-${ViolationStatusReason.policyChangedByUser}`,
        value: ViolationStatusReason.policyChangedByUser,
        displayName: "Resolved - " + beautifyCamelCaseString(ViolationStatusReason.policyChangedByUser),
        filterType: FilterTypesEnum.ViolationStatusReason,
        categoryName: FilterTypesEnum.ViolationStatusReason.toString(),
    },
    {
        id: `${FilterTypesEnum.ViolationStatusReason.toString()}-${ViolationStatusReason.fixed}`,
        value: ViolationStatusReason.fixed,
        displayName: "Resolved - " + beautifyCamelCaseString(ViolationStatusReason.fixed),
        filterType: FilterTypesEnum.ViolationStatusReason,
        categoryName: FilterTypesEnum.ViolationStatusReason.toString(),
    },
    {
        id: `${FilterTypesEnum.ViolationStatusReason.toString()}-${ViolationStatusReason.expired}`,
        value: ViolationStatusReason.expired,
        displayName: "Resolved - " + beautifyCamelCaseString(ViolationStatusReason.expired),
        filterType: FilterTypesEnum.ViolationStatusReason,
        categoryName: FilterTypesEnum.ViolationStatusReason.toString(),
    },
];
